import './info.css';
import React from 'react';
import { bio, education, experience, interests, leadership, projects, skills } from './exports';
import bbaldner from './img/me.jpg';
import ugImg from './img/Ultimate Games.png';
import vsImg from './img/volleystat.jpg';
import mvsImg from './img/mvs.jpg';
import pImg from './img/port.gif';

const projectImages = { ultimateGames: ugImg, volleystat: vsImg, mvs: mvsImg, portfolio: pImg };

function Info() {
    return (
        <main className="infomain" aria-label="About Brian Baldner">
            <header className="profile-header">
                <h1>Brian Baldner</h1>
                <p className="profile-subtitle">Software development · Data science · Baseball analytics</p>
                <div className="biosec">
                    <p>{bio}</p>
                    <img className="portrait" src={bbaldner} alt="Brian Baldner" />
                </div>
                <div className="profile-links">
                    <a href="mailto:bbaldner@uoregon.edu">Email</a>
                    <a href="https://www.linkedin.com/in/brianbaldner" target="_blank" rel="noreferrer">LinkedIn</a>
                    <a href="https://github.com/brianbaldner" target="_blank" rel="noreferrer">GitHub</a>
                </div>
            </header>

            <section aria-labelledby="experience-heading">
                <h2 id="experience-heading">Experience</h2>
                {experience.map((job) => (
                    <article className="resume-entry" key={job.organization}>
                        <div className="entry-heading">
                            <h3>{job.organization}</h3>
                            <span className="entry-date">{job.dates}</span>
                        </div>
                        <p className="entry-meta"><strong>{job.role}</strong> · {job.location}</p>
                        <ul>{job.highlights.map((highlight) => <li key={highlight}>{highlight}</li>)}</ul>
                    </article>
                ))}
            </section>

            <section aria-labelledby="education-heading">
                <h2 id="education-heading">Education</h2>
                <div className="resume-entry">
                    <div className="entry-heading">
                        <h3>{education.school}</h3>
                        <span className="entry-date">{education.dates}</span>
                    </div>
                    <p>{education.degree}</p>
                    <p className="entry-meta">{education.location} · GPA: {education.gpa}</p>
                    <p>{education.honors}</p>
                </div>
            </section>

            <section aria-labelledby="skills-heading">
                <h2 id="skills-heading">Technical Skills</h2>
                <dl className="skills-list">
                    {skills.map((group) => (
                        <div key={group.category}>
                            <dt>{group.category}</dt>
                            <dd>{group.items}</dd>
                        </div>
                    ))}
                </dl>
            </section>

            <section aria-labelledby="projects-heading">
                <h2 id="projects-heading">Projects</h2>
                {projects.map((project) => (
                    <article className="project-entry" key={project.name}>
                        <div>
                            <h3>{project.name}</h3>
                            <p className="entry-date">{project.date}</p>
                            {project.technologies && <p className="project-technologies">{project.technologies}</p>}
                            <p>{project.description}</p>
                        </div>
                        {project.image && <img src={projectImages[project.image]} alt={`${project.name} screenshot`} loading="lazy" />}
                    </article>
                ))}
            </section>

            <section aria-labelledby="leadership-heading">
                <h2 id="leadership-heading">Leadership</h2>
                <div className="resume-entry">
                    <div className="entry-heading">
                        <h3>{leadership.organization}</h3>
                        <span className="entry-date">{leadership.dates}</span>
                    </div>
                    <p className="entry-meta"><strong>{leadership.role}</strong> · {leadership.location}</p>
                    <p>{leadership.description}</p>
                </div>
            </section>

            <section aria-labelledby="interests-heading">
                <h2 id="interests-heading">Interests</h2>
                <p>{interests}</p>
            </section>

            <footer className="profile-credits">
                <h2>Credits</h2>
                <p>Inspired by <a href="https://henryheffernan.com/" target="_blank" rel="noreferrer">Henry Heffernan</a>. The page design takes inspiration from <a href="https://wikipedia.org/" target="_blank" rel="noreferrer">Wikipedia</a>. The desktop uses images from Microsoft Windows.</p>
            </footer>
        </main>
    );
}

export default Info;
